/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { LegacyPatientViewModel } from './LegacyPatientViewModel'; 

export function getLegacyPatientAddressOptions(patientCode: string, onSuccess?: (result?: LegacyPatientViewModel) => void) {
	return queryOptions({
		queryKey: ['legacy-patient-address', patientCode],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/legacy/scheduling/queries/getlegacypatientaddress/' + patientCode;
			const resp = await axios.get<LegacyPatientViewModel | null>(url);
	        const result = resp.data ?? null;
	        onSuccess?.(result ?? undefined);
	        return result;
        },
        select: (x) => x ?? undefined,
        enabled: Boolean(patientCode)
	});
}